import * as dateTypes from './action-types';
import moment from 'moment';

export function changeStartDate (date) {
  return {
    type: dateTypes.CHANGE_START_DATE,
    payload: moment(date).format('YYYY-MM-DD')
  };
}

export function changeEndDate (date) {
  return {
    type: dateTypes.CHANGE_END_DATE,
    payload: moment(date).format('YYYY-MM-DD')
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/datepicker-range/index.js
 **/